import styled from '@mui/material/styles/styled';
import Popper from '@mui/material/Popper';

const AutocompletePopper = styled(Popper)(({ theme }) => ({
    width: 320,
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.modal + 100,
    boxShadow: theme.shadows[1],
}));

export default AutocompletePopper;
